module.exports = __webpack_public_path__ + "fonts/fraunces-v31-latin-600.woff2";